import React from 'react'
import s from './Attempt.module.scss'

export const Attempt = ({ index, onClick, color, className, selected }) => {
  return (
    <div
      className={`${selected ? s.selected : ''} ${className} ${s.attempts}`}
      onClick={() => onClick(index)}
      style={{ backgroundColor: color }}
    >
      <div className={s.back} />
    </div>
  )
}
